import React from "react"
import Heading from "../../common/Heading"
import "./style.css"
import { useLanguage } from "../../../context/LanguageContext"

const Location = () => {
  const { content } = useLanguage()
  const { location } = content.home

  return (
    <>
      <section className='location padding'>
        <div className='container'>
          <Heading title={location.title} subtitle={location.subtitle} />

          <div className='content grid3 mtop'>
            {location.items.map((item) => (
              <div className='box' key={item.id}>
                <img src={item.cover} alt={item.name} />
                <div className='overlay'>
                  <h5>{item.name}</h5>
                  <p>
                    <label>{item.villas}</label>
                    <label>{item.offices}</label>
                    <label>{item.apartments}</label>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Location
